enum DossierOverviewItem {
  ATTACHMENT = 'ATTACHMENT',
  CUSTOMER_SIGNATURE = 'CUSTOMER_SIGNATURE',
  DEALER_SIGNATURE = 'DEALER_SIGNATURE',
  DIAGNOSTIC = 'DIAGNOSTIC',
  JOB = 'JOB',
  MEDIA = 'MEDIA',
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  TEST_DRIVE = 'TEST_DRIVE',
  TIME = 'TIME',
  WARRANTY = 'WARRANTY',
}

export default DossierOverviewItem;

export const DEFAULT_OVERVIEW_ITEMS = [DossierOverviewItem.JOB, DossierOverviewItem.CUSTOMER_SIGNATURE, DossierOverviewItem.MEDIA, DossierOverviewItem.ATTACHMENT]